import { useRef, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../../utils/Utilities.js";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import "./CreateEmployee.css";
import useAuth from "../../hooks/useAuth";
import TopBar from "./TopBar";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from "react-router-dom";

import { useStateDistrict } from "../../utils/Utilities.js"; // adjust path if needed


const CreateEmployee = () => {

  const [showValidation, setShowValidation] = useState(false);

  const {
    statesList,
    districtsList,
    stateId,
    setStateId,
    district,
    setDistrict,
    loadingStates,
    loadingDistricts,
  } = useStateDistrict();

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/listemployees");
  }

  // Initialize state for firstTabInput to store form data
  // const [firstTabInput, setFirstTabInput] = useState(""); 
  const [name, setname] = useState("");
  const [employee_code, setemployee_code] = useState("");
  const [id_card_type, setid_card_type] = useState("");
  const [id_card_number, setid_card_number] = useState("");
  const [date, setdate] = useState("");
  const [stateName, setStateName] = useState("");
  const [city, setcity] = useState("");
  const [pincode, setpincode] = useState("");
  const [address, setaddress] = useState("");
  const [mobile1, setmobile1] = useState("");
  const [mobile2, setmobile2] = useState("");
  const [email, setemail] = useState("");
  const [designation, setdesignation] = useState("");
  // const [showValidation, setShowValidation] = useState(false);
  const [showValidation2, setShowValidation2] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);


  // Modal control state
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Handle form completion
  const handleComplete = async () => {
    setIsSubmitting(true);

    try {
      const formattedDate = formatDate(date);

      // Build payload dynamically
      const payload = {
        employee_code,
        name,
        mobile1,
        mobile2,
        address,
        city,
        state: stateName,
        pincode,
        id_card_number,
        id_card_type,
        designation,
        franchise_id: auth.franchise_id,
        date_of_join: formattedDate,

        // include email only if it has a value
        ...(email?.trim() && { email: email.trim() }),
      };

      const response = await axiosPrivate.post(
        CREATE_EMPLOYEE,
        JSON.stringify(payload),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("Registration successful:", response.data);
      handleShowModal();

    } catch (error) {
      console.error("Error submitting form data:", error);
      alert("An error occurred while submitting your data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };




  // Validate first tab input
  const checkValidateTab = () => {
    if (name === "" || employee_code === "" || date === "") {
      return false;
    }
    return true; // Both fields are not empty
  };

  // Validate second tab input
  // const checkValidateTab2 = () => {
  //   if ( email === "" || designation === "") {
  //     return false;
  //   }
  //   return true; // Both fields are not empty
  // };

  // Error messages for validation
  const errorMessages = () => {
    setShowValidation(true); // Triggers inline messages
    // alert("Please fill in the required fields");
  };

  const errorMessages2 = () => {
    setShowValidation2(true); // Triggers inline messages
    // alert("Please fill in the required fields");
  };

  const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
  const EMAIL_REGEX =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const NAME_REGEX = /^(?!\s*$).+/;
  const CREATE_EMPLOYEE = "api/create-employee";



  return (
    <>
      <section className="franchbody">
        <div className="wrapper10">
          <div className="d-flex align-items-center">

            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">Employee List</button>
          </div>

          <center><h2 className="mul_head">Create Employee</h2></center>
          <FormWizard onComplete={handleComplete}>
            <FormWizard.TabContent title="Personal details" icon="ti-user">
              {/* <h3>Basic Information</h3> */}
              {/* <p>Some content for the first tab</p> */}

              <div className=" input-boxnew">
                <Row>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="name">Name<sup>*</sup></label>


                      <input
                        type="name"
                        className="form-control"
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                      />
                      {showValidation && !name && (
                        <div className="mt-1 reqstyl"> * Name is required</div>
                      )}

                    </div>
                  </Col>
                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="employee_code">Emp code<sup>*</sup></label>

                      <input
                        type="text"
                        className="form-control"
                        value={employee_code}
                        onChange={(e) => setemployee_code(e.target.value)}
                      />
                      {showValidation && !employee_code && (
                        <div className="mt-1 reqstyl"> *Emp Code is required</div>
                      )}
                    </div>
                  </Col>

                </Row>

                <Row>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="id_card_type">Id Type</label>

                      <select className="newregselect"
                        name="id_card_type"
                        value={id_card_type}
                        onChange={(e) => setid_card_type(e.target.value)}
                      >
                        <option value="">Select Id</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Voter Id">Voter Id</option>
                        <option value="Pan Card">Pan Card</option>

                      </select>
                      {showValidation && !id_card_type && (
                        <div className="mt-1 reqstyl"> *ID Card is required</div>
                      )}


                    </div>
                  </Col>

                  <Col>
                    <div className=" input-boxs">
                      <label htmlFor="id_card_number">Id Number</label>


                      <input
                        type="text"
                        className="form-control"
                        value={id_card_number}
                        onChange={(e) => setid_card_number(e.target.value)}
                      />
                      {showValidation && !id_card_number && (
                        <div className="mt-1 reqstyl"> *ID Card Number is required</div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row><Col>
                  <div className=" input-boxs">
                    <label htmlFor="date">Join Date<sup>*</sup></label>

                    <input
                      type="date"
                      className="form-control newregselect"
                      value={date}
                      onChange={(e) => setdate(e.target.value)}
                      style={{ fontSize: "15px" }}
                    />
                    {showValidation && !date && (
                      <div className="mt-1 reqstyl"> *Date is required</div>
                    )}
                  </div>
                </Col>
                  {/* <Col>
                    <div className=" input-boxs">
                      <label htmlFor="state">State<sup>*</sup></label>

                      <select className="newregselect"
                        name="state"
                        value={state}
                        onChange={(e) => setstate(e.target.value)}
                      >
                        <option value="">Select State</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Goa">Goa</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Haryana">Haryana</option>
                        <option value="Himachal Pradesh">Himachal Pradesh</option>
                        <option value="Jharkhand">Jharkhand</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Kerala">Kerala</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Manipur">Manipur</option>
                        <option value="Meghalaya">Meghalaya</option>
                        <option value="Mizoram">Mizoram</option>
                        <option value="Nagaland">Nagaland</option>
                        <option value="Odisha">Odisha</option>
                        <option value="Punjab">Punjab</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Sikkim">Sikkim</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Telangana">Telangana</option>
                        <option value="Tripura">Tripura</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="Uttarakhand">Uttarakhand</option>
                        <option value="West Bengal">West Bengal</option>
                        <option value="Andaman and Nicobar Islands">
                          Andaman and Nicobar Islands
                        </option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Dadra and Nagar Haveli and Daman and Diu">
                          Dadra and Nagar Haveli and Daman and Diu
                        </option>
                        <option value="Lakshadweep">Lakshadweep</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Puducherry">Puducherry</option>
                      </select>
                      {showValidation && !state && (
                        <div className="mt-1 reqstyl"> *State is required</div>
                      )}
                    </div>
                  </Col> */}
                  <Col>
                    <div className="input-boxs">
                      <label>State</label>

                      <select
                        className="newregselect"
                        value={stateId}
                        onChange={(e) => {
                          const selectedStateId = e.target.value;
                          setStateId(selectedStateId);

                          const selectedState = statesList.find(
                            (state) => state.state_id === Number(selectedStateId)
                          );

                          setStateName(selectedState?.state_name || "");
                        }}
                        required
                      >
                        <option value="">Select State</option>

                        {statesList.map((state) => (
                          <option key={state.state_id} value={state.state_id}>
                            {state.state_name} - ({state.state_code})
                          </option>
                        ))}
                      </select>

                      {showValidation && !stateId && (
                        <div className="mt-1 reqstyl">*State is required</div>
                      )}
                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="city">City</label>

                      <input
                        type="text"
                        className="form-control"
                        value={city}
                        onChange={(e) => setcity(e.target.value)}
                      />
                      {showValidation && !city && (
                        <div className="mt-1 reqstyl"> *City is required</div>
                      )}
                    </div>
                  </Col>
                  <Col>


                    <div className=" input-boxs">
                      <label htmlFor="pincode">Pincode</label>

                      <input
                        type="text"
                        className="form-control"
                        value={pincode}
                        onChange={(e) => setpincode(e.target.value)}
                      />
                      {showValidation && !pincode && (
                        <div className="mt-1 reqstyl"> *Pincode is required</div>
                      )}
                    </div>
                  </Col>

                </Row>


              </div>
            </FormWizard.TabContent>

            <FormWizard.TabContent
              title="Additional Info"
              icon="ti-settings"
              isValid={checkValidateTab()} // Validate based on first tab input
              validationError={errorMessages} // Show validation error if invalid
            >
              {/* <h3>Address and Contact</h3> */}

              <Row>
                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="address">Address</label>


                    <input
                      type="text"
                      className="form-control"
                      value={address}
                      onChange={(e) => setaddress(e.target.value)}

                    />
                    {showValidation2 && !address && (
                      <div className="mt-1 reqstyl"> *Address is required</div>
                    )}
                  </div>
                </Col>
                <Col>


                  <div className=" input-boxs">
                    <label htmlFor="mobile1">Mobile</label>

                    <input
                      type="text"
                      className="form-control"
                      value={mobile1}
                      onChange={(e) => setmobile1(e.target.value)}
                    />
                    {showValidation2 && !mobile1 && (
                      <div className="mt-1 reqstyl"> *Mobile1 is required</div>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>

                <Col>
                  <div className=" input-boxs">
                    <label htmlFor="mobile2">Mobile 2</label>


                    <input
                      type="mobile2"
                      className="form-control"
                      value={mobile2}
                      onChange={(e) => setmobile2(e.target.value)}
                    />
                    {showValidation2 && !mobile2 && (
                      <div className="mt-1 reqstyl"> *Mobile2 is required</div>
                    )}
                  </div>
                </Col>
                <Col>


                  <div className=" input-boxs">
                    <label htmlFor="email">Email<sup>*</sup></label>

                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                    />
                    {showValidation2 && !email && (
                      <div className="mt-1 reqstyl"> *Email is required</div>
                    )}
                  </div>
                </Col>
              </Row>

              <Row><Col>
                <div className=" input-boxs">
                  <label htmlFor="designation">Designation<sup>*</sup></label>


                  <input
                    type="text"
                    className="form-control"
                    value={designation}
                    onChange={(e) => setdesignation(e.target.value)}
                  />
                  {showValidation2 && !designation && (
                    <div className="mt-1 reqstyl"> *Designation is required</div>
                  )}
                </div>
              </Col>
                <Col></Col>
              </Row>
            </FormWizard.TabContent>



            <FormWizard.TabContent title="Review & Submit" icon="ti-check"
              // isValid={checkValidateTab2()} // Validate based on first tab input
              validationError={errorMessages2} // Show validation error if invalid
            >
              {/* <h3>Review Details</h3> */}
              {/* <p>Here is a summary of your details:</p> */}

              <Row>
                <Col><p className="multip"><span className="empspan">Name :</span> {name}</p> </Col>
                <Col><p className="multip"><span className="empspan">Emp Code :</span> {employee_code}</p></Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Id Type :</span> {id_card_type}</p></Col>
                <Col><p className="multip"><span className="empspan">Id Number :</span> {id_card_number}</p> </Col>
              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Date of Join :</span> {date}</p></Col>
                <Col><p className="multip"><span className="empspan">State :</span> {stateName}</p> </Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">City :</span> {city}</p></Col>
                <Col><p className="multip"><span className="empspan">Pincode :</span> {pincode}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Address :</span> {address}</p></Col>
                <Col><p className="multip"><span className="empspan">Mobile 1 :</span> {mobile1}</p></Col>

              </Row>
              <Row>
                <Col><p className="multip"><span className="empspan">Mobile 2 :</span> {mobile2}</p></Col>
                <Col><p className="multip"><span className="empspan">Email :</span> {email}</p></Col>

              </Row>

              <Row>
                <Col><p className="multip"><span className="empspan">Designation :</span> {designation}</p></Col>
                <Col></Col>
              </Row>


            </FormWizard.TabContent>
          </FormWizard>

        </div>
      </section>
      <TopBar />


      <Modal show={showModal} onHide={handleCloseModal} className="popmodal">
        <Modal.Header closeButton>
          <Modal.Title>  Employee Added successfully.</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          Employee Added successfully.
        </Modal.Body> */}
        <Modal.Footer>
          <Button variant="success"
            onClick={() => window.location.reload()}
          >
            Add another Employee
          </Button>
          <Button
            variant="info"
            onClick={() => navigate("/listemployees")}

          >
            Show EmployeeList
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateEmployee;
